import { render, staticRenderFns } from "./TrueWriting.vue?vue&type=template&id=4aeeacf5&scoped=true"
import script from "./TrueWriting.vue?vue&type=script&lang=js"
export * from "./TrueWriting.vue?vue&type=script&lang=js"
import style0 from "./TrueWriting.vue?vue&type=style&index=0&id=4aeeacf5&prod&scoped=true&lang=css"
import style1 from "./TrueWriting.vue?vue&type=style&index=1&id=4aeeacf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aeeacf5",
  null
  
)

export default component.exports